require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-ning-duong-selected-for-international-credit-union-development-educators.json") })
        }
      }, "path---articles-ning-duong-selected-for-international-credit-union-development-educators");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-ning-duong-selected-for-international-credit-union-development-educators!./.cache/json/articles-ning-duong-selected-for-international-credit-union-development-educators.json
// module id = 1716
// module chunks = 231608221292675